export default __webpack_public_path__ + "static/media/book_int_success.f6ee7a84.mp3";